module.exports = __webpack_public_path__ + "static/media/Titillium-Light.1ee277cf.otf";